import React, { Component } from 'react'
import { withStyles, FormHelperText } from '@material-ui/core'
import { DateTimePicker } from '@progress/kendo-dateinputs-react-wrapper'

export default withStyles(theme => ({
  dateTimePickerLabel: {
    display: 'block',
    fontSize: '11.5px',
    lineHeight: '11px',
    backgroundColor: '#fff',
    marginTop: '-3px',
    marginLeft: '40px',
    textAlign: 'left',
    position: 'absolute',
    zIndex: 1,
    padding: '0 5px',
  },
}))(
  class DateTime extends Component {
    componentDidMount() {
      const { search, handleChange } = this.props
      if (search && search.slice(0, 6) === '?date=') {
        handleChange(new Date(search.slice(6)))
      }
    }

    componentDidUpdate(prevProps) {
      const { search, handleChange, value, error } = this.props
      if (value === prevProps.value && error === prevProps.error) {
        if (search && search.slice(0, 6) === '?date=') {
          handleChange(new Date(search.slice(6)))
        }
      }
    }

    render() {
      const {
        value,
        handleChange,
        classes,
        error,
        title,
        style,
        fontSizeSmall,
        noMin,
        noHelperText,
        disabled,
        helperText,
      } = this.props

      if (error) {
        require('./PickerError.css')
      } else {
        require('./Picker.css')
      }

      if (fontSizeSmall) {
        require('./fontSizeSmall.css')
      }

      return (
        <div
          style={
            style
              ? { ...style, position: 'relative' }
              : { position: 'relative' }
          }
        >
          <div
            style={error ? { color: '#f44336' } : null}
            className={classes.dateTimePickerLabel}
          >
            {title}
          </div>
          {noMin ? (
            <DateTimePicker
              value={value}
              change={e => {
                handleChange(new Date(e.sender._value))
              }}
              readOnly={disabled}
            />
          ) : (
            <DateTimePicker
              value={value}
              change={e => {
                handleChange(new Date(e.sender._value))
              }}
              min={new Date(Date.now())}
              readOnly={disabled}
            />
          )}
          {/* <DateTimePicker
            // id="task-date-time-picker"
            value={value}
            change={e => handleChange(e.sender._value)}
            min={noMin ? null : new Date(Date.now())}
          /> */}
          {noHelperText ? null : (
            <FormHelperText error={Boolean(error)}>
              {error || helperText}
            </FormHelperText>
          )}
        </div>
      )
    }
  },
)
